/**
 * 
 * @returns 
 */
export const OrderItem = ({ title = '', content = '',}) => {
  return (
    <div className='order-item'>  
      <div className='order-item-label'>{title}</div>
      <div className='order-item-value'>{content}</div> 
    </div>
  )
};
